import type { CourseListView } from "~/business-areas/course/composables/course-list.hook";

export function useBlogPostRelatedCourse({
  id,
  course_page,
}: {
  id: string;
  course_page?: string;
}) {
  const { data } = useCourseList(`blog_${id}`, {
    slug: course_page?.split("/").at(-1) ?? "",
  });

  const relatedCourse = computed(
    () => data.value[0] as CourseListView | undefined,
  );

  return { relatedCourse };
}
